module.exports = __webpack_public_path__ + "media/images/lb/444-dec7fe46722261d7563677fc74e0073a.svg";